import React, { useState, useEffect } from 'react';
import PageLayout from '../../components/layout/PageLayout';
import Section from '../../components/layout/Section';
import HeroSection from '../../components/common/HeroSection';
import Button from '../../components/ui/Button';
import FeaturedArticle from './components/FeaturedArticle';
import ArticleCard from './components/ArticleCard';
import CategoryFilter from './components/CategoryFilter';
// Removed SearchBar import
import NewsletterSubscription from './components/NewsletterSubscription';
import TrendingInsights from './components/TrendingInsights';

const InsightsBlog = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  // Removed searchQuery state
  const [filteredArticles, setFilteredArticles] = useState([]);

  // Featured articles related to ONS METTLE's expertise
  const featuredArticles = [
    {
      id: 1,
      title: "5G Infrastructure Deployment: Engineering Excellence in Government Projects",
      excerpt: `Explore how advanced telecommunications infrastructure is transforming government operations. From AIIMS Deoghar to BPCL multi-state projects, discover the engineering excellence required for large-scale telecom deployments that connect clients to tomorrow's technology today.`,
      image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop",
      category: "Telecommunications",
      readTime: 12,
      publishDate: "Dec 15, 2024",
      slug: "5g-infrastructure-government-projects",
      author: {
        name: "Saurabh Joshi",
        avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face",
        role: "Business & Operations Head"
      }
    },
    {
      id: 2,
      title: "Custom Tower Design Solutions: Solving COLO Congestion Challenges",
      excerpt: `Innovation meets engineering in our approach to solving complex COLO congestion issues. Learn how custom tower design and laser technology for EMF surveys are revolutionizing telecommunications infrastructure deployment across multiple states.`,
      image: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&h=600&fit=crop",
      category: "Engineering Innovation",
      readTime: 8,
      publishDate: "Dec 12, 2024",
      slug: "custom-tower-design-colo-solutions",
      author: {
        name: "Rahul Kumar",
        avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
        role: "Technical Director"
      }
    }
  ];

  // Articles related to ONS METTLE's telecommunications and engineering expertise
  const articles = [
    {
      id: 3,
      title: "Jal Jeevan Mission: Engineering Water Infrastructure for Rural India",
      excerpt: "Discover how comprehensive water infrastructure projects under the Jal Jeevan Mission are transforming rural communities. Learn about the engineering challenges and innovative solutions in MP PHED Khandwa project.",
      image: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=600&h=400&fit=crop",
      category: "Infrastructure Engineering",
      readTime: 6,
      publishDate: "Dec 10, 2024",
      slug: "jal-jeevan-mission-engineering",
      trending: true,
      socialProof: { likes: 234, shares: 89, comments: 45 },
      author: {
        name: "Rajesh Kumar",
        avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face",
        role: "Project Head - Infrastructure"
      }
    },
    {
      id: 4,
      title: "Multi-State Telecommunications: BPCL Project Success Story",
      excerpt: "Explore the complexities of implementing telecommunications infrastructure across Gujarat, Madhya Pradesh, Maharashtra & Goa for BPCL. A case study in project management excellence.",
      image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=600&h=400&fit=crop",
      category: "Project Management",
      readTime: 7,
      publishDate: "Dec 8, 2024",
      slug: "bpcl-multi-state-telecom-project",
      socialProof: { likes: 189, shares: 67, comments: 32 },
      author: {
        name: "Priya Sharma",
        avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop&crop=face",
        role: "Project Manager - Telecommunications"
      }
    },
    {
      id: 5,
      title: "AIIMS Deoghar: Advanced Medical Infrastructure Engineering",
      excerpt: "Learn about the engineering excellence required for implementing state-of-the-art telecommunications and infrastructure systems at AIIMS Deoghar, supporting world-class healthcare delivery.",
      image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=600&h=400&fit=crop",
      category: "Medical Infrastructure",
      readTime: 5,
      publishDate: "Dec 5, 2024",
      slug: "aiims-deoghar-infrastructure",
      socialProof: { likes: 156, shares: 43, comments: 28 },
      author: {
        name: "Dr. Vikram Singh",
        avatar: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=100&h=100&fit=crop&crop=face",
        role: "Medical Systems Consultant"
      }
    },
    {
      id: 6,
      title: "Laser Technology in EMF Surveys: Innovation in Telecommunications",
      excerpt: "Discover how cutting-edge laser technology is revolutionizing EMF and Broadband surveys, enabling more accurate and efficient telecommunications infrastructure planning.",
      image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=600&h=400&fit=crop",
      category: "Technology Innovation",
      readTime: 9,
      publishDate: "Dec 3, 2024",
      slug: "laser-technology-emf-surveys",
      socialProof: { likes: 201, shares: 78, comments: 51 },
      author: {
        name: "Deepak Singh",
        avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face",
        role: "Network Architect"
      }
    },
    {
      id: 7,
      title: "Turnkey Project Management: End-to-End Service Excellence",
      excerpt: "Explore ONS METTLE's comprehensive turnkey capabilities including TSP, Civil, Electrical, and Mechanical services. Learn how integrated project management delivers superior results.",
      image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&h=400&fit=crop",
      category: "Project Management",
      readTime: 8,
      publishDate: "Nov 30, 2024",
      slug: "turnkey-project-management",
      socialProof: { likes: 178, shares: 56, comments: 39 },
      author: {
        name: "Anita Kumari",
        avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face",
        role: "Infrastructure Lead"
      }
    },
    {
      id: 8,
      title: "Flat Organizational Structure: Client-First Methodology in Action",
      excerpt: "Discover how ONS METTLE's flat organizational structure with dedicated Project Heads, Managers, and Expert Teams ensures superior client outcomes and project success.",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&h=400&fit=crop",
      category: "Organizational Excellence",
      readTime: 10,
      publishDate: "Nov 28, 2024",
      slug: "flat-organizational-structure",
      socialProof: { likes: 245, shares: 92, comments: 63 },
      author: {
        name: "Manoj Tiwari",
        avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
        role: "Network Specialist"
      }
    }
  ];

  // Categories relevant to ONS METTLE's expertise
  const categories = [
    { id: 'telecommunications', name: 'Telecommunications', icon: 'Radio', count: 24 },
    { id: 'engineering-innovation', name: 'Engineering Innovation', icon: 'Lightbulb', count: 18 },
    { id: 'project-management', name: 'Project Management', icon: 'Users', count: 15 },
    { id: 'infrastructure-engineering', name: 'Infrastructure Engineering', icon: 'Building', count: 12 },
    { id: 'technology-innovation', name: 'Technology Innovation', icon: 'Zap', count: 9 },
    { id: 'government-projects', name: 'Government Projects', icon: 'Shield', count: 11 }
  ];

  // Trending insights related to ONS METTLE's work
  const trendingArticles = [
    {
      id: 9,
      title: "5G Network Deployment: Best Practices for Government Infrastructure",
      image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=200&fit=crop",
      slug: "5g-network-government-infrastructure",
      views: "12.5K",
      comments: 89,
      shares: 234
    },
    {
      id: 10,
      title: "Tower Strengthening Solutions: Engineering for Future Capacity",
      image: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=200&h=200&fit=crop",
      slug: "tower-strengthening-solutions",
      views: "9.8K",
      comments: 67,
      shares: 189
    },
    {
      id: 11,
      title: "Site Survey Technologies: SBC, SST, NDT, and Core Cutting Advances",
      image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=200&h=200&fit=crop",
      slug: "site-survey-technologies",
      views: "8.2K",
      comments: 54,
      shares: 156
    }
  ];

  // Removed mock search suggestions

  useEffect(() => {
    let filtered = articles;

    // Filter by category
    if (activeCategory !== 'all') {
      const categoryName = categories.find(cat => cat.id === activeCategory)?.name;
      filtered = filtered.filter(article =>
        article.category.toLowerCase().includes(activeCategory.replace('-', ' ')) ||
        article.category === categoryName
      );
    }

    // Removed search query filtering logic

    setFilteredArticles(filtered);
  }, [activeCategory]); // Removed searchQuery from dependency array

  return (
    <PageLayout
      title="Insights & Thought Leadership | Ons Mettle Corporate"
      description="Explore strategic insights, industry trends, and transformation frameworks from Ons Mettle's thought leaders. Stay ahead with expert analysis and actionable strategies."
      keywords={['business insights', 'thought leadership', 'digital transformation', 'innovation strategy', 'market analysis']}
    >
      {/* Hero Section */}
      <HeroSection
        title={
          <>
            Engineering Excellence
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-brand-cyan to-brand-green">
              Insights
            </span>
          </>
        }
        description="Discover telecommunications engineering insights, government project expertise, and innovative solutions from ONS METTLE's experienced professionals. Connect to tomorrow's technology today with our industry-leading knowledge."
        backgroundClass="bg-gradient-to-br from-gray-800 via-gray-900 to-black text-gray-200"
      >
        <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6 mt-8">
          {/* Removed SearchBar component */}
          <Button
            variant="outline"
            className="bg-gray-700/50 border-gray-600/70 text-gray-200 hover:bg-gray-600/60 hover:border-gray-500/80 backdrop-blur-sm"
            iconName="Rss"
            iconPosition="left"
          >
            Subscribe to Feed
          </Button>
        </div>
      </HeroSection>

      {/* Featured Articles */}
      <Section background="bg-white" padding="py-16">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold font-heading text-gray-900 mb-4">
            Featured Engineering Insights
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            In-depth analysis and case studies from our telecommunications and infrastructure engineering projects
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {featuredArticles.map((article) => (
            <FeaturedArticle key={article.id} article={article} />
          ))}
        </div>
      </Section>

      {/* Main Content */}
      <Section background="bg-gray-50" padding="py-16">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 lg:gap-8">
          {/* Main Content */}
          <div className="lg:col-span-3">
            {/* Category Filter */}
            <CategoryFilter
              categories={categories}
              activeCategory={activeCategory}
              onCategoryChange={setActiveCategory}
            />

            {/* Articles Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 mb-12">
              {filteredArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>

            {/* Load More */}
            <div className="text-center">
              <Button
                variant="outline"
                size="lg"
                className="bg-white border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400 hover:text-primary"
                iconName="ChevronDown"
                iconPosition="right"
              >
                Load More Articles
              </Button>
            </div>
          </div>

          {/* Sidebar */}
          <div className="lg:col-span-1 space-y-6 lg:space-y-8 min-w-0">
            {/* Trending Insights */}
            <TrendingInsights articles={trendingArticles} />

            {/* Newsletter Subscription */}
            <NewsletterSubscription />
          </div>
        </div>
      </Section>
    </PageLayout>
  );
};

export default InsightsBlog;